import { NamedDefinitionPage } from './NamedDefinitionPage';

// Satamama Nedenleri — Ticari Pazarlama altında iki alanlı basit tanım ekranı
// (Müşteri Grubu deseni). Temsilci bir müşteride satış yapamadığında işaretleyeceği
// nedenler: "Cenaze nedeniyle kapalı", "Cuma Namazında", "Toptancıya Gitti" vb.
export function NonSaleReasonsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/nonsalereasons"
      listRoute="/non-sale-reasons"
      title="Satamama Nedenleri"
      subtitle="Temsilcinin müşteride satış yapamama nedenlerini tanımlayın, filtreleyin ve yönetin."
      codeLabel="Kod"
      descriptionLabel="Açıklama"
      newLabel="Yeni Satamama Nedeni"
      entityLabel="Satamama Nedeni"
    />
  );
}
